// Servicio de gestión de períodos académicos

import { get, post, put, del } from './api'
import { PAGINATION_CONFIG } from '../utils/constants'

export const periodoService = {
  /**
   * Obtener lista de períodos con paginación
   * @param {object} params - Parámetros de consulta
   * @returns {Promise<object>} Lista paginada de períodos
   */
  async getPeriodos(params = {}) {
    try {
      const queryParams = {
        page: params.page || 1,
        per_page: params.per_page || PAGINATION_CONFIG.DEFAULT_PAGE_SIZE,
        search: params.search || ''
      }

      const response = await get('/admin/periodos', queryParams)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al obtener períodos',
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: null
      }
    }
  },

  /**
   * Obtener lista simple de períodos sin paginación
   * @returns {Promise<object>} Lista de períodos
   */
  async getPeriodosSimple() {
    try {
      const response = await get('/admin/periodos/simple')
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data || [],
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al obtener períodos',
          data: []
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: []
      }
    }
  },

  /**
   * Crear nuevo período
   * @param {object} data - Datos del período
   * @returns {Promise<object>} Período creado
   */
  async createPeriodo(data) {
    try {
      const response = await post('/admin/periodos', data)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al crear período',
          errors: response.data?.errors || null,
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        errors: error.response?.data?.errors || null,
        data: null
      }
    }
  },

  /**
   * Obtener período por ID
   * @param {number} id - ID del período
   * @returns {Promise<object>} Período solicitado
   */
  async getPeriodo(id) {
    try {
      const response = await get(`/admin/periodos/${id}`)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Período no encontrado',
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        data: null
      }
    }
  },

  /**
   * Actualizar período
   * @param {number} id - ID del período
   * @param {object} data - Datos a actualizar
   * @returns {Promise<object>} Período actualizado
   */
  async updatePeriodo(id, data) {
    try {
      const response = await put(`/admin/periodos/${id}`, data)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al actualizar período',
          errors: response.data?.errors || null,
          data: null
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión',
        errors: error.response?.data?.errors || null,
        data: null
      }
    }
  },

  /**
   * Eliminar período
   * @param {number} id - ID del período
   * @returns {Promise<object>} Resultado de la eliminación
   */
  async deletePeriodo(id) {
    try {
      const response = await del(`/admin/periodos/${id}`)
      
      if (response.data && response.data.success) {
        return {
          success: true,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data?.message || 'Error al eliminar período'
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error de conexión'
      }
    }
  }
}
